import { defineAsyncComponent } from 'vue'
export default {
  "client-mode": defineAsyncComponent(() => import("/vercel/path0/apps/frontend/src/layouts/client-mode.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/apps/frontend/src/layouts/default.vue").then(m => m.default || m)),
  "not-found": defineAsyncComponent(() => import("/vercel/path0/apps/frontend/src/layouts/not-found.vue").then(m => m.default || m)),
  sandbox: defineAsyncComponent(() => import("/vercel/path0/apps/frontend/src/layouts/sandbox.vue").then(m => m.default || m))
}